import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import { Sc4ErrorMessageListCheck, Sc4ErrorMessageListInitialState } from './sc4-message-checker.actions';
import { Sc4MessageCheckerService } from './sc4-message-checker.service';
import { DataQualityErrorMessage, MessageCheckerStateModel } from '../models/message-checker.model';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

const initialState: MessageCheckerStateModel = {
  errorMessages: null,
  loaded: false,
};

@State<MessageCheckerStateModel>({
  name: 'sc4MessageChecker',
  defaults: initialState,
})
@Injectable()
export class Sc4MessageCheckerState {
  constructor(
    private sc4MessageCheckerService: Sc4MessageCheckerService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: MessageCheckerStateModel): MessageCheckerStateModel {
    return state;
  }
  @Selector()
  static getSc4ErrorMessageList(state: MessageCheckerStateModel): DataQualityErrorMessage {
    return state.errorMessages;
  }
  @Selector()
  static getLoaded(state: MessageCheckerStateModel): boolean {
    return state.loaded;
  }

  @Action(Sc4ErrorMessageListCheck)
  checkSc4ErrorMessageList(
    ctx: StateContext<MessageCheckerStateModel>,
    { payload }: Sc4ErrorMessageListCheck,
  ): Observable<void | MatSnackBarRef<SimpleSnackBar>> {
    return this.sc4MessageCheckerService.checkSc4Message(payload).pipe(
      take(1),
      map((errorMessages: DataQualityErrorMessage) => {
        ctx.patchState({ errorMessages, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc4ErrorMessageListInitialState)
  setInitialState(ctx: StateContext<MessageCheckerStateModel>): void {
    ctx.setState(initialState);
  }
}
